class EnvVariableReader {
  /**
   * Read a boolean env variable.
   *
   * @param _envVariable The env variable
   * @param _default The default.
   * @returns The environment variable.
   */
  static readBoolean(_envVariable, _default) {
    if (_envVariable) {
      return _envVariable.toUpperCase().trim() === 'TRUE';
    }

    return _default;
  }
}

module.exports = EnvVariableReader;
